import { mount } from "@vue/test-utils";
import CustomSendSmsLink from "@/components/core/CustomSendSmsLink";

describe("CustomSendSmsLink component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(CustomSendSmsLink);
  });

  it("Renders del component CustomSendSmsLink", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
